import styled, { css } from 'styled-components';
import { BKJIcon } from '../BKJIcon/index.js';
import { InputErrorMessageCSS } from '../common/index.js';
export const DropdownIcon = styled(BKJIcon) `
  margin-left: auto;
  min-width: fit-content;
  width: auto;
`;
export const ButtonWrapper = styled.button `
  display: flex;
  align-items: center;
  min-height: 38px;
  height: 38px;
  max-height: 38px;
  padding: 0 8px;
  transition: background-color 100ms linear;
  ${({ theme }) => theme.common.Ellipsis};
  ${({ isOpen, dropdownVariant }) => {
    if (dropdownVariant === 'Square')
        return css ``;
    if (dropdownVariant === 'SeamlessRounded')
        return (isOpen &&
            css `
          border-bottom-color: transparent;
          border-bottom-right-radius: 0;
          border-bottom-left-radius: 0;
        `);
    return css ``;
}};

  ${({ width }) => width &&
    css `
      width: ${width};
      max-width: ${width};
      min-width: ${width};
    `};

  &:hover {
    cursor: pointer;
  }

  position: relative;

  ${DropdownIcon} {
    transition: transform 150ms ease-in-out;
  }

  ${({ isOpen }) => isOpen &&
    css `
      ${DropdownIcon} {
        transition: transform 150ms ease-in-out;
        transform: scale(1, -1);
      }
    `};

  ${({ variant, theme }) => theme.select[variant].css};

  ${({ disabled }) => disabled &&
    css `
      background-color: ${({ theme }) => theme.colors.Grey3};
      border: none;
      cursor: default !important;
      pointer-events: none !important;
    `};
`;
export const HiddenSelectElement = styled.select `
  visibility: hidden;
  position: absolute;
  width: 100%;
  height: 100%;
  top: 0;
  left: 0;
`;
export const BKJSelectIcon = styled(BKJIcon) `
  height: 100%;
  display: flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  max-width: 24px;
  min-width: 24px;
  margin-right: 6px;
`;
export const Placeholder = styled.span `
  ${({ theme }) => theme.common.Ellipsis};
  text-align: left;
  margin: 0;
  width: 100%;
  ${({ placeholderColor }) => placeholderColor &&
    css `
      color: ${({ theme }) => theme.colors[placeholderColor]} !important;
    `};
`;
export const BKJSelectErrorMessage = styled.label `
  ${InputErrorMessageCSS}
`;
//# sourceMappingURL=BKJSelect.styled.js.map